import GraphRanges from "@/mixins/GraphRanges";
import { patientNamespace } from "@/store/modules/patient";
import { userNamespace } from "@/store/modules/user";
import { TemperatureTypes } from "@/store/modules/user/types";
import {
  c2Requested,
  c2RequestedGraph
} from "@/utilities/temperatureConversion";
import _ from "lodash";
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { MultiChartConfig } from "../shared/chart/MultiChartWithSharedRange";

@Component({})
export default class Temperature extends mixins(GraphRanges) {
  @Getter("graph", patientNamespace)
  graph!: any;

  @Getter("segmentRisk", patientNamespace)
  segmentRisk!: any;

  @Getter("preferenceTemperature", userNamespace)
  preferenceTemperature!: TemperatureTypes;

  get charts(): MultiChartConfig[] {
    const library = {
      scales: {
        yAxes: [
          {
            ticks: {
              maxTicksLimit: 8
            }
          }
        ]
      }
    };
    return [
      {
        data: c2RequestedGraph(
          this.graph(["Temperature"]),
          this.preferenceTemperature
        ),
        title: `Temperature (°${this.preferenceTemperature})*`,
        library: library,
        suggestedMin: c2Requested(34, this.preferenceTemperature),
        suggestedMax: c2Requested(40, this.preferenceTemperature)
      }
    ];
  }

  get medianDisclaimer(): string {
    return (
      "*Data points displayed for temperature represent the median over " +
      _.get(this, "atomList['temp'].trend", "15") +
      " minutes and are saved to the graph every 15 minutes."
    );
  }
}
